import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactComponent as IcMenuBook } from "../assets/images/icons/menu/ic-book.svg";
import { ReactComponent as IcFootprint } from "../assets/images/icons/menu/ic-footprint.svg";
import { ReactComponent as DefaultIcon } from "../assets/images/icons/menu/ic-menu-esg.svg";
import { ReactComponent as IcMenuDashboard } from "../assets/images/icons/menu/ic-menu-index.svg";
import { ReactComponent as IcMenuOrganize } from "../assets/images/icons/menu/ic-menu-organize.svg";
import { ReactComponent as IcMenuAccount } from "../assets/images/icons/menu/ic-text.svg";
import { ReactComponent as IcMenuUserSetting } from "../assets/images/icons/menu/ic-user-setting.svg";
import { ReactComponent as IcMenuUser } from "../assets/images/icons/menu/ic-user.svg";

// 透過 functionId 對應到 icon 圖片
// FIXME 需確認未來FunctionId的定義
const iconMap = {
  // "F10101": IcMenuDashboard,             // 儀表板
  F10103: IcMenuBook, // 盤查管理
  // "F20101": IcMenuUser,                   // 公司資料登錄
  // "F20201": IcMenuUser,                   // 角色管理
  // "F20301": IcMenuUserSetting,            // 帳戶活動
  F102: IcMenuOrganize, // 個人資料管理
  //"F104": IcFootprint,                      // 組織資料登錄
  F105: IcFootprint, // 產品碳足跡
  F106: IcMenuBook, // CBAM盤查
  F201: IcMenuUser, // 帳號管理
  F202: IcMenuUserSetting, // 權限管理
  F203: IcMenuAccount, // 帳戶活動管理
  B101: "fa-regular fa-user", // 使用者帳戶管理
  B102: "fa-solid fa-building", // 公司管理
  B201: "fa-solid fa-shield-halved", // 管理者權限設定
  B202: "fa-regular fa-envelope", // 訊息中心
  B203: "fa-regular fa-chart-bar", // 統計中心
  B20401: IcMenuDashboard, // 用戶資訊儀表板
  B205: "fa-solid fa-sitemap", // 系統設定
};

// 透過 functionId 取得 icon 圖片
export const getMenuIcon = (meunFunctionId) => {
  const icon = iconMap[meunFunctionId] || DefaultIcon;

  // 如果是字串，表示是 Font Awesome 圖示名稱，返回 FontAwesome 元件
  if (typeof icon === "string") {
    return (props) => <FontAwesomeIcon icon={icon} size="lg" {...props} />;
  }

  // 如果是 React 元件，直接返回
  return icon;
};
